import React from 'react';
import Spinner from 'components/loader/Spinner';
import DomainStatus from './components/DomainStatus';
import { Environment } from 'types/Environment';
import EmptyDomain from './components/EmptyDomain';
import useDomain from './hooks/useDomain';
import AwsStatuses from 'components/StatusWithTooltip/AwsStatuses';
import LoadingFailedStateDomain from './components/LoadingFailedStateDomain';
import UserProfiles from './components/UserProfiles';
import useUserProfiles from './hooks/useUserProfiles';
import { NSpinner } from '@innersource-nn/novoui-react';

type Props = {
    environment: Environment;
};

export default function SageMakerView({ environment }: Props) {
    const { domainStatus, domainExists, loading } = useDomain(
        environment?.environmentUri,
    );

    const { userProfiles } = useUserProfiles(environment);
    const { progress, status } = AwsStatuses[domainStatus?.status || ''] || {};
    return (
        <div>
            {loading ? (
                <Spinner />
            ) : !domainExists ? (
                <EmptyDomain
                    environmentUri={environment.environmentUri}
                    domainExists={domainExists}
                />
            ) : (progress || status === 'alert') &&
              userProfiles.length === 0 ? (
                <LoadingFailedStateDomain
                    environmentUri={environment.environmentUri}
                    loading={progress ?? false}
                    newDomain={!domainExists}
                />
            ) : (
                <div>
                    <DomainStatus
                        environmentUri={environment.environmentUri}
                        domainExists={domainExists}
                        domainStatus={domainStatus}
                    />
                    {progress ? (
                        <div className="py-32 flex flex-col justify-center items-center">
                            <NSpinner color="blue" size="medium" />
                            <div className="w-1/2 text-base text-true-blue flex flex-col items-center">
                                <h1 className="text-lg my-8 font-bold">
                                    User profiles update in progress...
                                </h1>
                                <p className="text-center">
                                    We are now updating your user profiles,
                                    please check back in a bit. The creation can
                                    take up to 1 - 3 minutes
                                </p>
                            </div>
                        </div>
                    ) : (
                        <UserProfiles environment={environment} />
                    )}
                </div>
            )}
        </div>
    );
}
